import { useState, useEffect } from "react";
import { getTiposDocumento } from "../../services/ClienteService.js";

// Catálogo de tipos de documento de venta desde el servicio
// (tabla tipo_documento, estructura estándar del ecosistema). Fuente única:
// sin fallback — si el servicio falla el catálogo queda vacío y las pantallas
// degradan sin columnas/bloques/opciones de tipo hasta que responda. Un tipo
// nuevo dado de alta en BD aparece aquí sin cambios de código.
const useTiposDocumento = (baseUrl) => {
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [loadingTipos, setLoadingTipos] = useState(true);

  useEffect(() => {
    const cargar = async () => {
      try {
        const data = await getTiposDocumento(baseUrl);
        setTiposDocumento(
          Array.isArray(data.tiposDocumento) ? data.tiposDocumento : []
        );
      } catch (error) {
        console.error("Error al cargar tipos de documento:", error);
        setTiposDocumento([]);
      } finally {
        setLoadingTipos(false);
      }
    };
    cargar();
  }, [baseUrl]);

  return { tiposDocumento, loadingTipos };
};

export default useTiposDocumento;